import axios, { HttpStatusCode } from "axios";
import { StatusMessageResponse } from "../../../common/interfaces/status-message-response";

function getErrorMessage(data: unknown): string | undefined {
  if (typeof data === 'object' && data !== null && 'message' in data) {
    const message = (data as { message?: unknown }).message;
    return typeof message === 'string' ? message : undefined;
  }

  if (typeof data === 'string') {
    try {
      return getErrorMessage(JSON.parse(data));
    } catch {
      return data || undefined;
    }
  }

  return undefined;
}

export async function processRequistions(data: Array<string>, token: string): Promise<StatusMessageResponse> {
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_URL+'/requisicao/processar', 
        {
          ids: data,
        }, 
        {
            headers: {
                Authorization: 'Bearer ' + token
            }
        }
      );
  
      const res = response.data; // Supondo que a resposta de criação seja retornado pelo backend
      return res;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return {
          statusCode: error.response?.status ?? HttpStatusCode.InternalServerError,
          message: getErrorMessage(error.response?.data) ?? 'Falha ao processar as requisições',
        }
      }

      return {
        statusCode: HttpStatusCode.InternalServerError,
        message: 'Falha ao processar as requisições',
      }
    }
}
